import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { LocationService } from './location.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'location', 'area', 'district', 'region', 'state', 'zone', 'country', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  locationForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private locationService: LocationService) {
    this.locationForm = this.fb.group({
      location: ['', Validators.required],
      country: ['', Validators.required],
      zone: ['', Validators.required],
      state: ['', Validators.required],
      region: ['', Validators.required],
      district: [''],
      area: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getCountryList();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.locationForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.getZoneList(object?.district?.state?.country?.id);
    this.getStateList(object?.district?.state?.zone?.id);
    this.getRegionList(object?.district?.state?.id);
    this.getDistrictList(object?.district?.region?.id);
    this.getAreaList(object?.district?.id);
    this.locationForm.patchValue({
      location: object.location_name,
      country: object?.district?.state?.country?.id,
      zone: object?.district?.state?.zone?.id,
      state: object?.district?.state?.id,
      region: object?.district?.region?.id ? object?.district?.region?.id : '',
      district: object?.district?.id,
      area: object.area.id ? object.area.id : '',
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const location = data.location_name.toLowerCase().includes(filter);
      return location;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.locationForm.valid) {
      const locationData = this.locationForm.value;
      let obj = {
        "location_name": locationData.location,
        "district_id": parseInt(locationData.district),
        "area_id": parseInt(locationData.area),
        "status": parseInt(locationData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.locationService.createLocation(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Locaiton created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.locationForm.valid) {
      const locationData = this.locationForm.value;
      let obj = {
        "location_name": locationData.location,
        "district_id": parseInt(locationData.district),
        "area_id": parseInt(locationData.area),
        "status": parseInt(locationData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.locationService.updateLocation(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Location updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.locationForm.patchValue({
      country: '',
      zone: '',
      state: '',
      region: '',
      district: '',
      area: '',
      location: '',
      status: ''
    });
    this.zoneList = [];
    this.stateList = [];
    this.regionList = [];
    this.areaList = [];
    this.districtList = [];
  }

  allowNumbersHyphenOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9\-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.locationService.getLocation().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  countryList: any = []
  getCountryList() {
    this.locationService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.countryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  stateList: any = []
  getStateList(zoneId?: any) {
    this.stateList = []
    this.regionList = [];
    this.districtList = []; 
    this.areaList = [];
    this.locationForm.patchValue({state:'', region:'', district: '', area:''})
    let id: any = this.locationForm.value.zone ? this.locationForm.value.zone : zoneId;
    this.locationService.getStateByZone(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.stateList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  zoneList: any = []
  getZoneList(countryId?: any) {
    this.zoneList = []
    let id: any = this.locationForm.value.country ? this.locationForm.value.country : countryId
    this.locationService.getZoneByCountry(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.zoneList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  regionList: any = []
  getRegionList(stateId?: any) {
    this.regionList = []
    this.districtList = [];
    this.areaList = [];
    this.locationForm.patchValue({region:'', district: '', area: ''})
    let id: any = this.locationForm.value.state ? this.locationForm.value.state : stateId;
    this.locationService.getRegionByState(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.regionList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  districtList: any = []
  getDistrictList(regionId?: any) {
    this.districtList = []
    this.areaList = [];
    this.locationForm.patchValue({district:'', area: ''})
    let id: any = this.locationForm.value.region ? this.locationForm.value.region : regionId;
    this.locationService.getDistrictByRegion(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.districtList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  areaList: any = []
  getAreaList(districtId?: any) {
    this.areaList = []
    this.locationForm.patchValue({area:''})
    let id: any = this.locationForm.value.district ? this.locationForm.value.district : districtId;
    this.locationService.getAreaByDistrict(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.areaList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

}
